import React, { useState, useCallback, Dispatch, SetStateAction } from "react";
import { useStyles } from "./CreditSimulator.style";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import {
  TextField,
  MenuItem,
  Select,
  Slider,
  useMediaQuery,
} from "@material-ui/core";
import { ButtonPrimary, CreditCategorySelector, NumericInput } from "..";
import { CreditSimulatorImage } from "@images";

type Props = {
  setPage: Dispatch<SetStateAction<number>>;
  setMonthPayment: Dispatch<SetStateAction<number>>;
  term: number;
  setTerm: Dispatch<SetStateAction<number>>;
  adjustDesktop?: React.CSSProperties;
  rate: number;
};

const CreditSimulator: React.FC<Props> = ({
  setPage,
  adjustDesktop,
  setMonthPayment,
  term,
  setTerm,
  rate,
}) => {
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width: 1240px)");

  const [amount, setAmount] = useState(0);

  const changePage = async () => {
    const payment = await Number(
      ((amount * rate) / (1 - (1 / (1 + rate)) ** Number(term))).toFixed(2)
    );
    // const amount2 = amount * rate;
    setMonthPayment(payment);
    setPage(2);
  };

  function valueLabelFor(value: number) {
    return `${value} años`;
  }

  const handleChange = () => {
    console.log(term);
  };
  return (
    <div className={classes.container} style={adjustDesktop}>
      <div className={classes.firstSection}>
        <div className="textContainer">
          <span className={classes.text}>
            En este simulador podrás
            <span className="style1"> elegir distintos plazos y montos </span>a
            pedir prestados para créditos de consumo, nosotros te entregaremos
            una
            <span className="style1">
              {" "}
              estimación de las cuotas que deberás pagar{" "}
            </span>
            para devolverlo en el fututo y el{" "}
            <span className="style1">monto total</span> que terminarás pagando.
          </span>
        </div>
        <div className="formBox">
          <div className="formItem">
            <span className="name nameDisabled">Categoría de crédito</span>
            <br />
            <div className="selectorContainer">
              <CreditCategorySelector
                placeholder={"crédito de consumo"}
                disabled
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="formItem">
            <span className="name">Monto</span>
            <br />
            <NumericInput
              name={""}
              value={amount}
              onChange={(e) => {
                setAmount(e.target.value as number);
              }}
            />
          </div>
          <div className="formItem">
            <span className="name beforeSlider">Plazo</span>
            <br />
            <TextField
              id="outlined-basic"
              label="Plazo en meses"
              variant="outlined"
              type="number"
              value={term}
              name="term"
              onChange={(e) => {
                setTerm(e.target.value as unknown as number);
              }}
            />
          </div>
        </div>
      </div>
      <div className={classes.secondSection}>
        <div className="imageContainer">
          <img src={CreditSimulatorImage} />
        </div>
        {!isMobile && (
          <div className="textContainer">
            <span className={classes.text}>
              <span className="style1">OJO </span>
              Recuerda que es sólo una estimación en base a las tasas promedio
              que están ofreciendo las entidades financieras actualmente. Puede
              diferir de lo que te ofrezcan personalmente dependiendo de tu
              nivel de ingresos y capacidad crediticia.
            </span>
          </div>
        )}
        <div className="buttonContainer">
          <ButtonPrimary
            className="buttonC"
            text="Continuar"
            secondaryVersion
            startIcon={<ArrowRightIcon />}
            onClick={() => {
              changePage();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CreditSimulator;
